import * as PullToRefresh from 'pulltorefreshjs';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, withLatestFrom } from 'rxjs/operators';

import { Location } from '@angular/common';
import {
    AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, LOCALE_ID, NgZone,
    OnDestroy, OnInit
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import {
    AcceptInformationAgreement, ChangeLanguage, HideInformationAgreementPopup, Logout,
    ShowInformationAgreementPopup
} from '../auth/auth.actions';
import { selectInformationAgreementShowPopup, selectLoggedUser } from '../auth/auth.selectors';
import { UICommand } from '../base-components/ui-command';
import { AppState } from '../core.state';
import {
    BaseNotification
} from '../entities/document-notifications/base-notification/base-notification.model';
import {
    SetCertificationNotificationAsRead, SetPublicHealthRecordNotificationAsRead
} from '../entities/document-notifications/store/document-notifications.actions';
import {
    selectDocumentNotifications
} from '../entities/document-notifications/store/document-notifications.selectors';
import { Role } from '../entities/user/role.enum';
import { User } from '../entities/user/user.model';
import { LocalizeService } from '../localize/localize.service';
import {
    InformationAgreementEmployeeEnComponent
} from './information-agreement/information-agreement-employee/en/information-agreement-employee-en.component';
import {
    InformationAgreementEmployeeComponent
} from './information-agreement/information-agreement-employee/information-agreement-employee.component';
import {
    InformationAgreementFreelanceEnComponent
} from './information-agreement/information-agreement-freelance/en/information-agreement-freelance-en.component';
import {
    InformationAgreementFreelanceComponent
} from './information-agreement/information-agreement-freelance/information-agreement-freelance.component';
import {
    InformationAgreementComponent
} from './information-agreement/information-agreement.component';
import { LayoutState } from './state/layout.reducer';
import { getLayoutState } from './state/layout.selectors';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  public loggedUser$: Observable<User>;

  public isMain$: Observable<boolean>;
  public commands$: Observable<UICommand[]>;
  public title$: Observable<string>;
  public layoutState$: Observable<LayoutState>;
  documentNotifications$: Observable<BaseNotification[]>;

  public roles = Role;

  public selectedLanguage: string ;

  private ptrInstance: PullToRefresh.PullToRefreshInstance;
  private loggedUserSubscription: Subscription;
  private informationAgreementSubscription: Subscription;
  private informationAgreementAcceptSubscription: Subscription;
  private closeInformationAgreementDialogSubscription: Subscription;
  private dialogRef: MatDialogRef<InformationAgreementComponent, any>;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    private cd: ChangeDetectorRef,
    private zone: NgZone,
    private translateService: TranslateService,
    private modal: MatDialog,
    private localizeService: LocalizeService

  ) {}

  ngAfterViewInit(): void {
    // this.zone.runOutsideAngular(() => {
    //   this.ptrInstance = PullToRefresh.init({
    //     mainElement: "#ptr-content",
    //     distIgnore: 150,
    //     instructionsPullToRefresh: this.translateService.instant(
    //       "Trascina giù per aggiornare la pagina"
    //     ),
    //     instructionsRefreshing: this.translateService.instant("Aggiornamento"),
    //     instructionsReleaseToRefresh: this.translateService.instant(
    //       "Rilascia per aggiornare"
    //     ),
    //     onRefresh() {
    //       window.location.reload();
    //     },
    //   });
    // });
  }

  ngOnInit(): void {
    this.loggedUser$ = this.store.pipe(select(selectLoggedUser));
    this.loggedUserSubscription = this.loggedUser$.subscribe((user) => {
      if (user && user.showInformationAgreement && !user.informationAgreement) {
        this.store.dispatch(new ShowInformationAgreementPopup());
      }
    });

    this.selectedLanguage = this.localizeService.getCurrentLocale();

    this.layoutState$ = this.store.pipe(select(getLayoutState));

    // HACK LAYOUT NOT UPDATING
    this.layoutState$
      .pipe(debounceTime(0))
      .subscribe(() => this.cd.detectChanges());
    this.documentNotifications$ = this.store.pipe(
      select(selectDocumentNotifications)
    );

    this.informationAgreementSubscription = this.store
      .pipe(
        select(selectInformationAgreementShowPopup),
        withLatestFrom(this.store.select(selectLoggedUser))
      )
      .subscribe(([show, loggedUser]) => {
        if (show) {
          if (!this.dialogRef) {
            // mostro la popup
            if (loggedUser.role === this.roles.Employee) {
              if (this.localizeService.getCurrentLocale() === 'en-GB'){
                this.dialogRef = this.modal.open<InformationAgreementEmployeeEnComponent>(
                  InformationAgreementEmployeeEnComponent,
                  {
                    panelClass: 'fullscreen-modal',
                    width: '100vw',
                    height: '100vw',
                    disableClose: true,
                  }
                );
              }
              else{
                this.dialogRef = this.modal.open<InformationAgreementEmployeeComponent>(
                  InformationAgreementEmployeeComponent,
                  {
                    panelClass: 'fullscreen-modal',
                    width: '100vw',
                    height: '100vw',
                    disableClose: true,
                  }
                );
              }
            } else {
              if (this.localizeService.getCurrentLocale() === 'en-GB'){
                this.dialogRef = this.modal.open<InformationAgreementFreelanceEnComponent>(
                  InformationAgreementFreelanceEnComponent,
                  {
                    panelClass: 'fullscreen-modal',
                    width: '100vw',
                    height: '100vw',
                    disableClose: true,
                  }
                );
              }else{
                this.dialogRef = this.modal.open<InformationAgreementFreelanceComponent>(
                  InformationAgreementFreelanceComponent,
                  {
                    panelClass: 'fullscreen-modal',
                    width: '100vw',
                    height: '100vw',
                    disableClose: true,
                  }
                );
              }
            }
            this.informationAgreementAcceptSubscription = this.dialogRef.componentInstance.accept.subscribe(
              () => {
                this.store.dispatch(new AcceptInformationAgreement());
              }
            );
            this.closeInformationAgreementDialogSubscription = this.dialogRef
              .afterClosed()
              .subscribe(() => {
                this.store.dispatch(new HideInformationAgreementPopup());
              });
          }
        } else {
          if (this.dialogRef) {
            this.dialogRef.close();
            this.dialogRef = null;
          }
        }
      });
  }

  ngOnDestroy() {
    this.ptrInstance?.destroy();
    this.informationAgreementSubscription?.unsubscribe();
    this.closeInformationAgreementDialogSubscription?.unsubscribe();
    this.loggedUserSubscription?.unsubscribe();
    this.informationAgreementAcceptSubscription?.unsubscribe();
  }

  public back() {
    this.location.back();
  }

  public onLogout() {
    this.store.dispatch(new Logout());
  }

  public setSelectedLanguage(lang: string){
    this.store.dispatch(new ChangeLanguage(lang));
  }

  onSetNotificationAsRead(notification: BaseNotification) {
    if (notification.isCertification) {
      this.store.dispatch(
        new SetCertificationNotificationAsRead(notification.id)
      );
    } else {
      this.store.dispatch(
        new SetPublicHealthRecordNotificationAsRead(notification.id)
      );
    }
  }
}
